import { gql } from "graphql-tag";
import FollowedPromptType from "types/FollowedPromptType";

export default gql`
  mutation PinPrompt($promptId: Int!) {
    upsertResponse: upsert_followed_prompt(prompt_id: $promptId) {
      followedPrompt: followed_prompt {
        ...FollowedPromptFragment
      }
    }
  }
`;

export interface PinPromptMutationData {
  upsertResponse: {
    followedPrompt: FollowedPromptType;
  };
}